<template>
  <!--刷新界面的图标-->
<div class="xm-icon-help">
  <div class="xm-icon-help-icon" @click="openPageHelp">
    <div class="xm-icon-help-text" v-if="isFrameType" :style="getTechnologyFrameTextColor">  
      {{ t('layout.header.help') }}
    </div>
    <a-tooltip v-else>
      <template #title>{{t('界面帮助信息')}}</template>
      <div class="icon-span">
          <question-circle-outlined/>
        </div>
      </a-tooltip>
  </div>
  <a-drawer
      v-model:visible="visible"
      class="xm-icon-help-drawer"
      :width="900"
      :mask="false"
      :title="t('帮助助手')"
      placement="right"
  >
    <div class="helpcenter-wrapper" style="overflow: hidden;margin:auto;background-color:#eee;">
      <div class="help-body-content" v-if="helpHtml" v-html="helpHtml">
      </div>
      <a-result v-if="!helpHtml" status="warning" title="还未编写当前界面的帮助信息，敬请期待.">
        <template #extra>
          <a-button key="console" type="primary">敬请期待</a-button>
        </template>
      </a-result>


<!--      <div class="foot-bar" @click="openHelpCenter"><span class="goHelp">{{t('进入帮助中心')}}</span></div>-->
    </div>
  </a-drawer>
</div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "xm-icon-help",
});
</script>

<script lang="ts" setup>
import {Tooltip as ATooltip,Drawer as ADrawer,Result as AResult,Button  as AButton} from "ant-design-vue";
import {QuestionCircleOutlined} from "@ant-design/icons-vue";
import { useI18n } from 'vue-i18n';
import {useIconHelp} from "@/layouts/default/header/components/hooks/useIconHelp";
import { useAppFrame } from '@/hooks/useAppFrame';
const { t } = useI18n();
const { isFrameType,getTechnologyFrameTextColor } = useAppFrame();

const {
  openHelpCenter,
  helpHtml,
  openPageHelp,
  visible
}=useIconHelp();


/**
 * 关闭窗口
 * @param event
 */
const handlerClick=function (event:any){
  const isNotSectionCtl = event.target.closest('.xm-icon-help') || event.target.closest('.help-body-content')|| event.target.closest('.helpcenter-wrapper');
  if (!isNotSectionCtl) {
    visible.value=false;
  }
}
onBeforeUnmount(()=>{
  document.body.removeEventListener('click',handlerClick)
})
onMounted(()=>{
  document.body.addEventListener("click", handlerClick);

})

</script>

<style type="text/css" lang="less">
.xm-icon-help {
  .icon-span {
    height: 100%;
    cursor: pointer;
    display: flex;
    align-items: center;

    svg {
      font-size: 16px;
    }
  }
  &-text{
    font-size: 14px;
    color: #FFF;
  }
}
.xm-icon-help-drawer{
  .ant-drawer-body{
    padding: 0;
  }
  .helpcenter-wrapper{
    height: 100%;
    padding: 6px 12px;
    .help-body-content{
      background-color: #fff;
      height: calc(100% - 50px);
      overflow-y: auto;
      overflow-x: hidden;

      img {
        cursor: default;
        display: inline!important;
        max-width: 100%;
        min-height: 20px;
        min-width: 20px;
      }
    }
  }
  .foot-bar {
    height: 50px;
    width:100%;
    line-height: 50px;
    text-align: center;
    position: absolute;
    bottom:2px;
    left:0;
    display: flex;
    justify-content: center;
    border-top: 1px solid #eee;

    .goHelp {
      color: var(--primary-color,#0a6eff);
      cursor: pointer;
      font-size: 14px;
      font-weight: 700;
    }
  }
}

</style>
